import { FAQ_SECTIONS } from '../content/faq';
import { PageFaqSection } from './ds';
import { FaqAccordionList } from './faq/FaqAccordionList';

export function FAQStatic() {
  return (
    <PageFaqSection
      titleAs="h1"
      title={
        <>
          Asked &amp;
          <br />
          answered.
        </>
      }
    >
      <FaqAccordionList sections={FAQ_SECTIONS} />
    </PageFaqSection>
  );
}
